import { ApiResponseWithPaging } from '@dispatch/shared/types';
import { AxiosResponse } from 'axios';

export function mapResponseWithPaging<TData>(
  response: AxiosResponse<TData, unknown>
): ApiResponseWithPaging<TData> {
  return {
    data: response.data,
    continuationToken: response.headers['continuation-token'],
    statusCode: response.status,
    hasFilters: hasFiltersApplied(response),
  };
}

function hasFiltersApplied(response: AxiosResponse<unknown, unknown>) {
  const NONFILTER_KEYS = ['pageSize'];
  if (!response?.config?.params) return false;
  return (
    Object.keys(response.config.params).filter(
      (x) => !NONFILTER_KEYS.includes(x)
    ).length > 0
  );
}
